var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',_vm._g({},_vm.$listeners),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.itemTitle)}}),_c('HeadArrowUpIcon',{staticClass:"link-arrow"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }